import _ from "lodash";

export async function getStates() {
  const result = await (
    await fetch("https://servicodados.ibge.gov.br/api/v1/localidades/estados")
  ).json();

  const states = _.orderBy(result, ["nome"], ["asc"]);

  return states;
}

export async function getCities(ID) {
  const result = await (
    await fetch(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${ID}/municipios`
    )
  ).json();

  return result;
}
